import uuid from 'uuid/v4';

export const getUuid = length => {
  const id = uuid();
  const cutLength = id.length - length;
  return id.slice(0, -cutLength);
};
